"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageAssignmentCache = void 0;
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const local_storage_assignment_shim_1 = require("./local-storage-assignment-shim");
class LocalStorageAssignmentCache extends js_client_sdk_common_1.AbstractAssignmentCache {
    constructor(storageKeySuffix) {
        super(new local_storage_assignment_shim_1.LocalStorageAssignmentShim(storageKeySuffix));
    }
    setEntries(entries) {
        entries.forEach(([key, value]) => {
            if (key && value) {
                this.delegate.set(key, value);
            }
        });
    }
    getEntries() {
        return Promise.resolve(Array.from(this.entries()));
    }
}
exports.LocalStorageAssignmentCache = LocalStorageAssignmentCache;
//# sourceMappingURL=local-storage-assignment-cache.js.map